import * as React from 'react'
import { useThemeUI } from 'theme-ui'
import WireFrameCell from '../../../../elements/wireframe-cell'
import { Badge } from '@uswitch/spark'

import CellBase from './cell-base'
import { WireFrame } from './wireframe-cell'

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  badges?: React.ReactNode[]
  preTitle?: React.ReactNode
  rowTitle?: React.ReactNode
  subtitle?: React.ReactNode
  addons?: React.ReactNode[]
  image?: React.ReactNode
  card?: React.ReactNode
  isWireFrame?: boolean
}

const ProductTableHeader: React.FC<HeaderProps> = ({
  badges = [],
  preTitle,
  rowTitle,
  subtitle,
  addons = [],
  image,
  card = false,
  isWireFrame = false,
}) => {
  const {
    theme: {
      compounds: { 'product-table': { padding: { paddingBottom = ['0', 'sm'] } = {} } = {} },
    },
  }: any = useThemeUI()

  const pb = paddingBottom || '0'

  const wireFrameStyles = {
    image: {
      width: ['45%', '15%'],
      marginRight: 'xxs',
      height: '70px',
      borderRadius: '3px',
    },
    title: {
      width: ['93%', '55%'],
      height: '14px',
    },
  }

  // For displaying USPs in product table header
  const uspJsx = (subtitle: string[]) => {
    return subtitle.map((item: string) => {
      const terms = ['voucher', 'bill credit', 'reward card', 'gift card']

      const voucherStyles = terms.some(term => item.toLowerCase().includes(term))
        ? { border: '1px solid rgb(130, 202, 80)' }
        : {}

      const blackFridayStyles = item.toLowerCase().includes('black friday')
        ? { background: 'black', color: 'white', border: '1px solid black', fontWeight: 'bold' }
        : {}

      const badgeStyles = {
        margin: '5px 5px 0 0',
        border: '1px solid rgb(255, 170, 85)',
        background: 'white',
        ...voucherStyles,
        ...blackFridayStyles,
      }

      return (
        <Badge size={'medium'} sx={badgeStyles}>
          {item}
        </Badge>
      )
    })
  }

  const subtitleJsx = (subtitle: React.ReactNode) => {
    if (Array.isArray(subtitle)) {
      return uspJsx(subtitle)
    }

    return (
      <span
        sx={{
          marginTop: '10px',
          fontSize: 'xs',
          variant: 'compounds.product-table.row.subtitle',
        }}
      >
        {subtitle}
      </span>
    )
  }

  return (
    <div
      sx={{
        pb: image ? '' : 'xs',
      }}
    >
      <div
        sx={{
          borderBottom: image ? '0' : '1px solid',
          paddingBottom: image ? pb : 'sm',
          marginTop: badges.length ? 0 : -6,
          display: 'flex',
          alignItems: card ? ('baseline' as const) : ('center' as const),
          flexDirection: card ? ('column' as const) : ('row' as const),
          minHeight: card ? ['0', '0', '160px'] : '0',
          variant:
            badges.length && !card
              ? 'compounds.product-table.badge-wrapper'
              : badges.length && card
              ? 'compounds.product-table.badge-wrapper.card'
              : undefined,
        }}
      >
        {isWireFrame && <WireFrameCell styles={wireFrameStyles.image} />}
        {!isWireFrame && image && image}
        {isWireFrame && <WireFrame type='header' />}
        {!isWireFrame && rowTitle && (
          <CellBase
            sx={{
              marginX: -8,
              marginY: -6,
            }}
          >
            {preTitle && (
              <span
                sx={{
                  fontSize: 'xs',
                  variant: 'compounds.product-table.row.pretitle',
                }}
              >
                {preTitle}
              </span>
            )}
            <h3
              sx={{
                margin: 0,
                variant: `compounds.product-table.${image && 'variants.redesign.'}row.title`,
                pl: card && '0 !important',
              }}
            >
              {rowTitle}
            </h3>
            {subtitle && subtitleJsx(subtitle)}
          </CellBase>
        )}
        {addons}
      </div>
    </div>
  )
}

export default ProductTableHeader
